/** @format */

import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Table, TableBody, TableCell, TableFooter, TableHead, TableRow, withStyles } from '@material-ui/core';

import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import RemoveButton from '../../../components/Buttons/RemoveButton';
import TableHeaderContentCell from '../../../components/Table/TableHeaderContentCell';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';

interface BillingSelectedPlatformResellerListProps {
    classes: any;
    selectedPlatformUsers: Array<{ mainname: string; nip: string; id: number }>;
    removePlatformResellerCallback: (params: { mainname: string; nip: string; id: number }) => void;
    clearPlatformResellersCallback: () => void;
    searchBillingCallback?: () => void;
}

const BillingSelectedPlatformResellerList = (props: BillingSelectedPlatformResellerListProps): React.ReactElement => {
    const classes = props.classes;
    const tableCellRoot = { root: classes.tableCellRoot };
    const tableStickyCommand = { root: classes.tableStickyCommand };
    const tableRootNotMinWidth = {root: classes.tableRootNotMinWidth};
    const tableControlStickyHeader = {root: classes.tableControlStickyHeader};

    return (
        <Table classes={tableRootNotMinWidth}>
            <TableHead>
                <TableRow>
                    <TableCell classes={tableControlStickyHeader} colSpan={3} align="left" padding="none">
                        {props.selectedPlatformUsers.length > 0 && props.searchBillingCallback && (
                            <CustomTextButtom
                                size={'lg'}
                                callback={props.clearPlatformResellersCallback}
                                callbackParam={{}}
                                color="primary"
                                label="general:common.clear"
                            />
                        )}
                        {props.selectedPlatformUsers.length > 0 && props.searchBillingCallback && (
                            <CustomTextButtom
                                size={'lg'}
                                callback={props.searchBillingCallback}
                                callbackParam={{}}
                                color="primary"
                                label="general:common.search"
                            />
                        )}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell classes={tableStickyCommand} padding="none" align="left">
                        <TableHeaderContentCell textAlign="left" title="general:common.commands" onlyFilter={true} />
                    </TableCell>
                    <TableCell classes={tableStickyCommand} align="left" padding="none">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="simcard:list.partner"
                            fieldName="msisdn"
                            showSort={false}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="number"
                        />
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {props.selectedPlatformUsers &&
                    props.selectedPlatformUsers.map((el: { mainname: string; nip: string; id: number }) => {
                        return (
                            <TableRow key={el.id}>
                                <TableCell classes={tableCellRoot}>
                                    <RemoveButton
                                        callback={props.removePlatformResellerCallback}
                                        callbackParam={{ mainname: el.mainname, nip: el.nip, id: el.id }}
                                    />
                                </TableCell>
                                <TableCell classes={tableCellRoot}>{el.mainname}</TableCell>
                            </TableRow>
                        );
                    })}
            </TableBody>
            <TableFooter></TableFooter>
        </Table>
    );
};

export default withStyles(oplAppStyle)(BillingSelectedPlatformResellerList);
